export const projectsData = [
  {
    id: "fgc-presenter",
    title: "FGC Presenter",
    tagline: "High-Performance Dual-Screen Church Presentation Software",
    category: "Desktop",
    description: "A highly specialized presentation software designed specifically for church media teams to project lyrics, Bible verses, and media seamlessly across multiple screens with sub-50ms latency.",
    problem: "Traditional presentation platforms are often bloated, resource-heavy, and lack fast keyboard-driven search for multilingual Scripture and lyrics during dynamic live services.",
    solution: "Engineered a dedicated Electron application with React and Tailwind CSS. Implemented a dual-process IPC bridge ensuring instantaneous synchronization between operator controls and display monitors without tearing or frame drops.",
    architecture: "Electron multi-process architecture (Main process + dual isolated Renderers), IPC message bus with custom event emitter, and local SQLite database for offline-first resilience.",
    keyFeatures: [
      "Sub-50ms multi-display projection synchronization",
      "Instant fuzzy search across multiple Bible translations & songs",
      "Offline-first architecture with zero internet dependency",
      "Dynamic background themes, lower-thirds, and typography controls",
      "Quick-switch blackouts, logos, and alert banner overlays"
    ],
    metrics: [
      { label: "Sync Latency", value: "<50ms" },
      { label: "Offline Uptime", value: "100%" },
      { label: "Display Outputs", value: "Multi-Screen" }
    ],
    tags: ["React", "Tailwind CSS", "Electron", "Node.js", "SQLite"],
    githubLink: "https://github.com/RSanjeyan",
    demoLink: "#"
  },
  {
    id: "smartmed-pharmacy",
    title: "SmartMed Pharmacy",
    tagline: "Enterprise Pharmacy & Inventory Management System",
    category: ".NET / C#",
    description: "Comprehensive pharmacy management software for tracking inventory in real-time, managing point-of-sale checkout, processing prescription history, and generating financial analytics.",
    problem: "Pharmacies struggle with drug expiration leakages, untracked batch numbers, manual inventory calculation errors, and slow peak-hour billing bottlenecks.",
    solution: "Built a robust desktop solution using C#, .NET, and Microsoft SQL Server utilizing FIFO batch management, automated stock replenishment triggers, and high-speed barcode checkout.",
    architecture: "Layered architecture (.NET / C#), Repository and Unit of Work design patterns, ACID-compliant SQL Server procedures, and Crystal Reports for fiscal auditing.",
    keyFeatures: [
      "Real-time stock deduction and expiry date notifications",
      "Instant barcode scanner integration for point-of-sale",
      "Patient prescription history and dosage record logs",
      "Role-based security authentication (Admin, Pharmacist, Cashier)",
      "Automated daily profit, loss, and inventory valuation reporting"
    ],
    metrics: [
      { label: "Inventory SKUs", value: "10,000+" },
      { label: "Checkout Time", value: "<1.5s" },
      { label: "Data Accuracy", value: "99.9%" }
    ],
    tags: ["C#", ".NET", "SQL Server", "WPF", "Crystal Reports"],
    githubLink: "https://github.com/RSanjeyan",
    demoLink: "#"
  },
  {
    id: "church-management",
    title: "Church Management System",
    tagline: "Cloud-Based Parishioner & Ministry Resource Platform",
    category: "Full Stack",
    description: "A robust cloud dashboard to organize parishioner records, manage event schedules, generate financial contribution reports, and streamline volunteer coordination.",
    problem: "Parish records were scattered across disconnected files, making giving receipts difficult to track and leading to room scheduling clashes.",
    solution: "Developed a modern React application powered by Firebase real-time database, enabling multi-device access with instant cloud synchronization and zero local maintenance.",
    architecture: "React SPA backed by Firebase Firestore real-time listeners, Firebase Authentication, Cloud Functions, and Firebase Storage.",
    keyFeatures: [
      "Family-grouped member directory with search and filtering",
      "Tithe and contribution accounting with automated receipt exports",
      "Interactive ministry calendar preventing facility double-booking",
      "Volunteer roster assignment and event participation logs"
    ],
    metrics: [
      { label: "Cloud Sync", value: "Real-time" },
      { label: "Receipts", value: "100% Digital" },
      { label: "Availability", value: "99.9%" }
    ],
    tags: ["React", "Tailwind CSS", "Firebase", "Cloud Firestore"],
    githubLink: "https://github.com/RSanjeyan",
    demoLink: "#"
  }
];

export const projectCategories = ["All", "Full Stack", ".NET / C#", "Desktop"];
